<script setup lang="ts">
import { ActionButton, StatusTag } from '@taler/ui'
import { ref, watch } from 'vue'
import { useI18n } from 'vue-i18n'
import type { Frecency, Target } from '../internal/targets.ts'
import AccountCombobox from '@/features/entries/components/AccountCombobox.vue'

const props = defineProps<{
  accountId: string | undefined
  targets: readonly Target[]
  frecency: ReadonlyMap<string, Frecency>
  isSaving: boolean
  errorDetail: string | undefined
}>()

const emit = defineEmits<{ save: [accountId: string] }>()

const { t } = useI18n()

const selection = ref<string | undefined>(props.accountId)
watch(
  () => props.accountId,
  (value) => {
    selection.value = value
  },
)

function save(): void {
  if (selection.value !== undefined) emit('save', selection.value)
}
</script>

<template>
  <div class="flex flex-col gap-[var(--space-block)]">
    <label class="flex flex-col gap-[var(--space-hair)]">
      <span class="text-[length:var(--text-step-1)] text-[color:var(--color-text-muted)]">{{
        t('paymentAccount.field')
      }}</span>
      <div data-field="default-payment-account">
        <AccountCombobox
          id="default-payment-account"
          :label="t('paymentAccount.field')"
          :model-value="selection"
          :targets="targets"
          :frecency="frecency"
          @update:model-value="(value) => (selection = value)"
        />
      </div>
    </label>
    <StatusTag v-if="errorDetail !== undefined" tone="danger" role="alert">
      {{ errorDetail }}
    </StatusTag>
    <div>
      <ActionButton
        size="lg"
        type="button"
        :disabled="selection === undefined || isSaving"
        class="font-medium"
        @click="save"
      >
        {{ isSaving ? t('paymentAccount.saving') : t('paymentAccount.save') }}
      </ActionButton>
    </div>
  </div>
</template>
